import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GeneratePostService } from '@admin-panel/infra';
import { GetAdminKnownCitiesResponse } from '@core-http';

export class GetKnownCitiesQueryHandler {
  private readonly generatePostService: GeneratePostService = inject(GeneratePostService);

  query(): Observable<string[]> {
    return this.generatePostService
      .getKnownCities()
      .pipe(map((response: GetAdminKnownCitiesResponse) => [...response.knownCities]));
  }
}
